import { MenuItemType } from "../../upbar/sub-components/selected-page-container/selected-page-container";
import { Menu } from "antd";
import { ItemType } from "antd/es/menu/hooks/useItems";

import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IDownloadSystemSelectionProps {
  selectedKeys: string[];
  setSelectedKeys: (value: string[]) => void;
  systemsList: MenuItemType[];
}

export const DownloadSystemSelection = ({
  selectedKeys,
  setSelectedKeys,
  systemsList
}: IDownloadSystemSelectionProps) => {
  const [isItemSelected, setIsItemSelected] = useState<boolean>(false);

  const location = useLocation();

  const downloadPagePattern = /(download.*)/;

  const menuBuilder = (menuList: MenuItemType[]): ItemType[] => {
    return menuList.map((item: MenuItemType) => {
      const menuItems = {
        ...item,
        children: undefined,
        onClick: () => {
          setSelectedKeys(item.key ? [item.key.toString()] : []);
        },
      };

      return menuItems;
    });
  };

  const menuItems = menuBuilder(systemsList);

  useEffect(() => {
    const isLocationMatch = downloadPagePattern.test(location.pathname);

    if (isLocationMatch) {
      setIsItemSelected(true);
    } else {
      setIsItemSelected(false);
    }
  }, [location]);

  return (
    <Menu
      selectedKeys={isItemSelected ? selectedKeys : []}
      mode="horizontal"
      items={menuItems}
      style={{
        width: "200%",
        fontSize: "20px",
        fontWeight: 500,
        backgroundColor: "white",
        border: "none",
      }}
    ></Menu>
  );
};
